var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"success","title":"Realiza o download do modelo processado com informações do convênio"},on:{"click":function($event){$event.stopPropagation();return _vm.download()}}},[_c('span',[_c('i',{staticClass:"fa fa-cog"}),_vm._v(" Documento Processado")])])
}
var staticRenderFns = []

export { render, staticRenderFns }